import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ct_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errText(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const CT_SKILLS = ["Decomposition", "Pattern Recognition", "Abstraction", "Algorithmic Thinking"];

export const CT_COLORS = {
  Decomposition: "#EC4899",
  "Pattern Recognition": "#EAB308",
  Abstraction: "#A855F7",
  "Algorithmic Thinking": "#0EA5E9",
};

export const CT_BG = {
  Decomposition: "#FBCFE8",
  "Pattern Recognition": "#FEF08A",
  Abstraction: "#E9D5FF",
  "Algorithmic Thinking": "#BAE6FD",
};

export function bandColor(b) {
  if (b === "Strong") return "bg-emerald-100 text-emerald-800 border-emerald-200";
  if (b === "Developing") return "bg-amber-100 text-amber-800 border-amber-200";
  if (b === "Needs Support") return "bg-rose-100 text-rose-800 border-rose-200";
  return "bg-slate-100 text-slate-600 border-slate-200";
}

export async function downloadFile(path, filename) {
  const token = localStorage.getItem("ct_token");
  const res = await fetch(`${API}${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: "include",
  });
  if (!res.ok) throw new Error("Download failed");
  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
